import { useState } from 'react'
import { useRouter } from 'next/router'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { css, keyframes } from '@emotion/react'
import nextI18nextConfig from '../../../next-i18next.config'
import { useTranslation } from 'next-i18next'
import fa from 'yup-locale-fa'
import { NEXT_REPONSES } from '../../constants'
import { useUser } from '../../hooks/User'

yup.setLocale(fa)

const bubbleColor = (opacity) => `rgba(157,157,157,${opacity})`
const square = keyframes`
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(calc(-100vh - 180px)) rotate(600deg);
    }`
const bubblesCss = css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 1;

    li {
        position: absolute;
        list-style: none;
        display: block;
        width: 40px;
        height: 40px;
        background-color: ${bubbleColor(0.15)};
        bottom: -160px;
        animation: ${square} 25s infinite;
        transition-timing-function: linear;
    }
    li:nth-of-type(1) {
        left: 10%;
    }
    li:nth-of-type(2) {
        left: 20%;
        width: 80px;
        height: 80px;
        animation-delay: 2s;
        animation-duration: 17s;
    }
    li:nth-of-type(3) {
        left: 25%;
        animation-delay: 4s;
    }
    li:nth-of-type(4) {
        left: 40%;
        width: 60px;
        height: 60px;
        animation-duration: 22s;
        background-color: ${bubbleColor(0.25)};
    }
    li:nth-of-type(5) {
        left: 70%;
    }
    li:nth-of-type(6) {
        left: 80%;
        width: 120px;
        height: 120px;
        animation-delay: 3s;
        background-color: ${bubbleColor(0.2)};
    }
    li:nth-of-type(7) {
        left: 32%;
        width: 160px;
        height: 160px;
        animation-delay: 7s;
    }
    li:nth-of-type(8) {
        left: 55%;
        width: 20px;
        height: 20px;
        animation-delay: 15s;
        animation-duration: 40s;
    }
    li:nth-of-type(9) {
        left: 25%;
        width: 10px;
        height: 10px;
        animation-delay: 2s;
        animation-duration: 40s;
        background-color: ${bubbleColor(0.3)};
    }
    li:nth-of-type(10) {
        left: 90%;
        width: 160px;
        height: 160px;
        animation-delay: 11s;
    }
`
export default function Signin({...args}) {
    const { t } = useTranslation(['common', 'validation'])
    const schema = yup.object().shape({
        username: yup
            .string()
            .label(t('نام کاربری', { ns: 'common' }))
            .required(),
        password: yup
            .string()
            .label(t('رمز عبور', { ns: 'common' }))
            .required(),
    })

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    })

    const [errorMsg, setErrorMsg] = useState('')
    const router = useRouter()
    const [isRevealPwd, setIsRevealPwd] = useState(false) // for show password checkbox
    const { login } = useUser()

    async function onSubmit(data) {
        if (errorMsg) setErrorMsg('')

        try {
            const response = await fetch('/api/auth/signin', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    username: data.username,
                    password: data.password,
                    otp: data.otp,
                }),
            })
            let responseObject = await response.json()
            if (response.status === 200) {
                login()
                const urlParams = new URLSearchParams(window.location.search)
                if (/^\/.+/.test(urlParams.get('returnUrl')))
                    router.push(urlParams.get('returnUrl'))
                else router.push(responseObject.returnUrl)
            } else {
                
                setErrorMsg(responseObject.message)
            }
        } catch (error) {
            console.error('An unexpected error happened occurred:', error)
            setErrorMsg('خطا در ارتباط با سرور')
        }
    }

    return (
        <div
            style={{
                display: 'flex',
                height: '100vh',
                overflow: 'hidden',
                direction: 'rtl',
                minWidth: 300,
            }}
        >
            <div
                style={{
                    width: 600,
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '-10px 0px 20px 0px #00000094',
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column', gap: 10, position: 'relative', zIndex: 2 }}>
                    <div style={{
                        aspectRatio: '16:9',
                        width: '100%',
                        height: 100,
                        backgroundSize: 'contain',
                        background: 'no-repeat center / contain url(/img/project/logo.png)',
                    }}>
                    </div>
                    <form
                        onSubmit={handleSubmit(onSubmit)}
                        style={{
                            width: 240,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8,
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <div style={inputWrapperStyle}>
                            <input
                                style={inputStyles}
                                name="username"
                                autoComplete="username"
                                type="text"
                                dir="auto"
                                placeholder={t(
                                    'نام کاربری',
                                    { ns: 'common' },
                                )}
                                {...register('username')}
                            />
                            {errors?.username?.message && <div>{errors.username.message}</div>}
                        </div>
                        <div style={inputWrapperStyle}>
                            <input
                                style={inputStyles}
                                name="password"
                                autoComplete="current-password"
                                type={
                                    isRevealPwd
                                        ? 'text'
                                        : 'password'
                                }
                                dir="auto"
                                placeholder={t('گذرواژه', {
                                    ns: 'common',
                                })}
                                {...register('password')}
                            />
                            {errors?.password?.message && <div>{errors.password.message}</div>}
                        </div>
                        <div style={{ ...inputWrapperStyle, gap: 24, alignItems: 'center', display: 'flex' }}>
                            <label style={{ whiteSpace: 'nowrap' }}>کد دو عاملی:</label>
                            <input
                                style={{ ...inputStyles, }}
                                name="otp"
                                autoComplete="off"
                                type="text"
                                dir="ltr"
                                placeholder={t('در صورت لزوم', {
                                    ns: 'common',
                                })}
                                {...register('otp')}
                            />
                            {errors?.otp?.message && <div>{errors.otp.message}</div>}
                        </div>
                        <div style={{
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            fontFamily: 'Vazir FD',
                            ...inputWrapperStyle,
                        }}>
                            <div dir="rtl">
                                <input
                                    id="show-password"
                                    type="checkbox"
                                    onClick={() =>
                                        setIsRevealPwd(
                                            (prevState) =>
                                                !prevState,
                                        )
                                    }
                                />
                                <label htmlFor='show-password'>
                                    {' ' + t('نمایش گذرواژه', {
                                        ns: 'validation',
                                    })}
                                </label>
                            </div>
                            <button
                                style={{
                                    padding: '5px 1.5rem',
                                    color: '#fff',
                                    backgroundColor: '#3f51b5',
                                    border: 'none',
                                    borderRadius: 5,
                                    cursor: 'pointer',
                                }}
                                type="submit"
                            >
                                {t('ورود', {
                                    ns: 'common',
                                })}
                            </button>
                        </div>

                        <p className="text-red-500 mt-5 text-right">
                            {errorMsg}
                        </p>
                    </form>
                </div>
                <ul css={bubblesCss}>
                    {[...Array(12).keys()].map((_, idx) => <li key={idx}></li>)}
                </ul>
            </div>
            <div
                style={{
                    backgroundImage: 'url(/img/shared/signin.webp)',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    flex: 1,
                }}
            ></div>
        </div>
    )
}

export async function getServerSideProps({ locale, query }) {
    if (query?.['token'] !== process.env.SIGN_IN_URL.replace('/auth/', ''))
        return NEXT_REPONSES.NOT_FOUND_R0
    return {
        props: {
            ...(await serverSideTranslations(
                locale,
                ['common', 'validation'],
                nextI18nextConfig,
            )),
            buildTime: new Date().toISOString(),
        },
    }
}

const inputStyles = {
    padding: '5px 10px',
    border: '1px solid #ccc',
    borderRadius: '2px',
    width: '100%',

}
const inputWrapperStyle = {
    width: '100%',
}